import { DashboardWidgetDefinition } from 'src/app/shared/dashboard-grid';
import { ALERT_LIST_WIDGET } from './widgets/alert-list/alert-list.widget';
import { ALERTS_MAP_WIDGET } from './widgets/alerts-map/alerts-map.widget';
import { AccessControl } from 'src/app/shared/authentication/access-control';
import { INCIDENT_BREAKDOWN_WIDGET } from './widgets/incident-breakdown/incident-breakdown.widget';
import { LOCATION_MAP_WIDGET } from './widgets/location-map/location-map.widget';
import { METRIC_WIDGET } from './widgets/metric/metric.widget';
import { OPEN_INCIDENTS_WIDGET } from './widgets/open-incidents/open-incidents.widget';
import { RECENT_ALERTS_WIDGET } from './widgets/recent-alerts/recent-alerts.widget';

/** The widgets, each also requiring `feature`; the user sees and adds only the widgets of features they have. */
export function gatedByFeature<const W extends readonly DashboardWidgetDefinition[]>(feature: string, widgets: W): W {
  return widgets.map((widget) => ({
    ...widget,
    permissions: [feature, ...(widget.permissions ?? [])],
  })) as unknown as W;
}

const ENTERPRISE_WIDGETS = [
  METRIC_WIDGET,
  RECENT_ALERTS_WIDGET,
  ALERT_LIST_WIDGET,
  ALERTS_MAP_WIDGET,
  OPEN_INCIDENTS_WIDGET,
  INCIDENT_BREAKDOWN_WIDGET,
  LOCATION_MAP_WIDGET,
] as const;

/** Every widget the dashboard registers; each feature contributes its own set to the one dashboard. */
export const DASHBOARD_WIDGETS = [
  ...gatedByFeature(AccessControl.FeatureEnterpriseDashboard, ENTERPRISE_WIDGETS),
] as const;
